export enum StockLocationType {
  WAREHOUSE = "WAREHOUSE",
  SITE = "SITE",
  VEHICLE = "VEHICLE",
}

export const StockLocationTypeLabel: Record<StockLocationType, string> = {
  [StockLocationType.WAREHOUSE]: "Warehouse",
  [StockLocationType.SITE]: "Site",
  [StockLocationType.VEHICLE]: "Vehicle",
};
